import { render, staticRenderFns } from "./SystemTagManagementTalentListItem.vue?vue&type=template&id=0838a510"
import script from "./SystemTagManagementTalentListItem.vue?vue&type=script&lang=js"
export * from "./SystemTagManagementTalentListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports